export default function GS_Fill() {
  return (
    <div className="p-4">
      <h1>GS Fill</h1>
    </div>
  );
}
